import React, { useEffect, useState } from "react"
import * as landing from "./landing.module.css"
import { doc } from "prettier"

function LandingGradient() {
  const [mouse, setMouse] = useState({ x: 0, y: 0 })
  useEffect(() => {
    document.addEventListener("mousemove", e => {
      const winWidth = window.innerWidth
      const winHeight = window.innerHeight
      const mouseX = Math.round((e.pageX / winWidth) * 100)
      const mouseY = Math.min(Math.round((e.pageY / winHeight) * 100), 100)
      setMouse({ x: mouseX, y: mouseY })
    })
  }, [])
  return (
    <>
      <div className={landing.gradientWrapper}></div>
      <div className={landing.noiseWrapper}></div>
      <div className={landing.whiteWrapper}></div>
    </>
  )
}

export default LandingGradient
